export const canStartPosSession = (userId: number | undefined, responsibleIds: number[]) =>
  userId !== undefined && responsibleIds.includes(userId);

export const ownsActivePosSession = (userId: number | undefined, currentOperatorId?: number) =>
  userId !== undefined && currentOperatorId === userId;
